import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh-CN', label: '中文' }
];

/**
 * Language selector. Lets the user load the portal in English or
 * Simplified Chinese; the choice is persisted and re-applied on the next visit
 * (see Translations/config.ts).
 *
 * Hidden by default. A build opts in by setting REACT_APP_SHOW_LANGUAGE_SWITCHER=true
 * (e.g. the China deployment); any other value keeps the switcher hidden.
 */
const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  if (process.env.REACT_APP_SHOW_LANGUAGE_SWITCHER !== 'true') {
    return null;
  }

  const current = i18n.language && i18n.language.toLowerCase().startsWith('zh') ? 'zh-CN' : 'en';

  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    void i18n.changeLanguage(event.target.value);
  };

  return (
    <select
      className="language-switcher"
      aria-label="Select language"
      data-testid="language-switcher"
      value={current}
      onChange={onChange}
    >
      {LANGUAGES.map((language) => (
        <option key={language.code} value={language.code}>
          {language.label}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
